(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      const stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerOffsetTop = 0;
      this.stuckTicking = false;

      this.cacheHeaderOffset();
      this.setHeaderHeight();

      this.onResize = () => {
        this.cacheHeaderOffset();
        this.setHeaderHeight();
        if (this.headerIsAlwaysSticky) this.updateStuckHeader();
      };
      window.addEventListener('resize', this.onResize);

      this.header?.querySelector('.tudor-header__logo')?.addEventListener('load', () => {
        this.cacheHeaderOffset();
        this.setHeaderHeight();
        if (this.headerIsAlwaysSticky) this.updateStuckHeader();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.setupStuckHeader();
      } else {
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      requestAnimationFrame(() => {
        this.cacheHeaderOffset();
        this.setHeaderHeight();
        if (this.headerIsAlwaysSticky) this.updateStuckHeader();
      });
    }

    setupStuckHeader() {
      this.headerPlaceholder = document.createElement('div');
      this.headerPlaceholder.className = 'section-header__placeholder';
      this.headerPlaceholder.hidden = true;
      this.header.insertAdjacentElement('afterend', this.headerPlaceholder);

      this.onStuckScroll = () => {
        if (this.stuckTicking) return;
        this.stuckTicking = true;
        requestAnimationFrame(() => {
          this.updateStuckHeader();
          this.stuckTicking = false;
        });
      };

      window.addEventListener('scroll', this.onStuckScroll, { passive: true });

      const announcement = document.querySelector('.announcement-bar-section');
      if (announcement) {
        this.announcementObserver = new MutationObserver(() => {
          this.cacheHeaderOffset();
          this.updateStuckHeader();
        });
        this.announcementObserver.observe(announcement, {
          attributes: true,
          attributeFilter: ['hidden'],
        });
      }
    }

    cacheHeaderOffset() {
      if (!this.header) return;

      const wasStuck = this.header.classList.contains('section-header--stuck');
      if (wasStuck) {
        this.header.classList.remove('section-header--stuck');
      }

      this.headerOffsetTop = this.header.offsetTop;

      if (wasStuck) {
        this.header.classList.add('section-header--stuck');
      }
    }

    updateStuckHeader() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldStick = scrollTop >= this.headerOffsetTop;

      this.header.classList.toggle('section-header--stuck', shouldStick);

      if (this.headerPlaceholder) {
        this.headerPlaceholder.hidden = !shouldStick;
        if (shouldStick) {
          this.headerPlaceholder.style.height = `${this.header.offsetHeight}px`;
        }
      }

      this.setHeaderHeight();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.hideHeaderOnScrollUp) {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      }
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
      if (this.onStuckScroll) {
        window.removeEventListener('scroll', this.onStuckScroll);
      }
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
      if (this.announcementObserver) {
        this.announcementObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
